<tr *ngIf="editableElements.length === 1; else expand" class="root">
  <td class="td-w-5"></td>
  <td class="td-w-45 variable-name">
    <div class="flex flex-row flex-between">
      <div>
        {{ editableElements[0]?.attributes.transId | translate }}
        <span *ngIf="editableElements[0]?.isNew || editableElements[0]?.modified" class="m-l-2px">
          <em class="fa fa-light fa-asterisk unsaved"></em>
        </span>
      </div>
    </div>
  </td>
  <td class="td-w-auto previous td-input text-center p-r-1">
    <i class="fa-solid fa-sigma" *ngIf="previousIsSum"></i>
    {{ previousValue }}
  </td>
  <td class="td-w-auto current td-input text-right p-r-1">
    <div class="flex flex-row"
         triggers="mouseenter:mouseleave mouseenter:click"
         [popover]="editableElements[0]?.attributes?.value ? infoTemplateRoot : null"
         container="body">
      <em *ngIf="editableElements[0]?.attributes?.comment" class="fa fa-light fa-comment m-l"></em>
      <number-input #input
        [(ngModel)]="editableElements[0]?.attributes.value"
        (ngModelChange)="markAsDirty(editableElements[0])"
        [readOnly]="readOnly"
        [classes]="[readOnly ? 'disabled' : '']"
        [type]="'decimal'"
        [maxDigits]="4">
      </number-input>
    </div>
    <ng-template #infoTemplateRoot>
      <gp-variable-elements-popover [contract]="contract" [variable]="editableElements[0]">
      </gp-variable-elements-popover>
    </ng-template>
  </td>
  <td class="td-w-10 next td-input text-center p-r-1">
    <i class="fa-solid fa-sigma" *ngIf="nextIsSum"></i>
    {{ nextValue }}
  </td>
  <td class="td-w-10">{{ editableElements[0]?.attributes.unitTransId | translate }}</td>
  <td class="td-w-auto row-actions">
    <ng-container *ngTemplateOutlet="controls; context: { variable: editableElements[0], isNested: false, type: type }"></ng-container>
  </td>
</tr>

<ng-template #expand>
  <ng-container>
    <tr class="root">
      <td (click)="toggleExpand()">
        <span class="fa fa-light" [class.fa-caret-right]="!expanded" [class.fa-caret-down]="expanded"></span>
      </td>
      <td>{{ editableElements[0]?.attributes.transId | translate }}</td>
      <td class="previous td-input text-right p-r-1">
        <i class="fa-solid fa-sigma" *ngIf="previousIsSum"></i>
        {{ previousValue | gpNumber:'DECIMAL_UP_TO_4_DIGIT' }}
      </td>
      <td class="current td-input text-right p-r-1">
        <i class="fa-solid fa-sigma"></i>
        {{ getVariableSum(editableElements) | gpNumber:'DECIMAL_UP_TO_4_DIGIT' }}
      </td>
      <td class="next td-input text-right p-r-1">
        <i class="fa-solid fa-sigma" *ngIf="nextIsSum"></i>
        {{ nextValue | gpNumber:'DECIMAL_UP_TO_4_DIGIT' }}
      </td>
      <td>{{ editableElements[0]?.attributes.unitTransId | translate }}</td>
      <td></td>
    </tr>
    <ng-container *ngIf="expanded">
      <tr *ngFor="let variable of editableElements; let i = index;">
        <td></td>
        <td class="variable-name">
          <div class="flex flex-row flex-between">
            <div>
              -
              <span *ngIf="variable?.isNew || variable?.modified" class="m-l-2px">
                <em class="fa fa-light fa-asterisk unsaved"></em>
              </span>
            </div>
          </div>
        </td>
        <td class="previous td-input text-right p-r-1">{{ getVariableValue(variable, previousPayPeriod) }}</td>
        <td class="current td-input text-right p-r-1">
          <div class="flex flex-row"
                triggers="mouseenter:mouseleave mouseenter:click"
                [popover]="variable?.attributes?.value ? infoTemplate : null"
                container="body">
            <em *ngIf="variable?.attributes?.comment" class="fa fa-light fa-comment m-l"></em>
            <number-input #input
              [(ngModel)]="variable?.attributes.value"
              (ngModelChange)="markAsDirty(variable)"
              [readOnly]="readOnly"
              [classes]="[readOnly ? 'disabled' : '']"
              [type]="'decimal'"
              [maxDigits]="4">
            </number-input>
          </div>
          <ng-template #infoTemplate>
            <gp-variable-elements-popover [contract]="contract" [variable]="variable">
            </gp-variable-elements-popover>
          </ng-template>
        </td>
        <td class="next td-input text-right p-r-1">{{ getVariableValue(variable, nextPayPeriod) }}</td>
        <td>-</td>
        <td class="row-actions">
          <ng-container *ngTemplateOutlet="controls; context: { variable: variable, isNested: true, type: type }"></ng-container>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #controls let-variable="variable" let-nested="isNested" let-type="type">
  <div class="flex flex-center-x-y" *ngIf="!isEmployeeFormEmbedded">
    <div class="flex-center-x-y">
      <em class="actions fa fa-light pointer m-r" [class.fa-pencil-alt]="!readOnly"
          [class.fa-eye]="readOnly && variable?.attributes?.value"
          container="body" [tooltip]="getActionTooltip(variable) | translate" aria-hidden="true"
          (click)="editVariable(variable)">
      </em>
    </div>
    <div class="flex-center-x-y">
      <em [ngClass]="{'invisible': readOnly || !variable?.attributes?.value}"
          class="actions fa fa-light fa-trash-alt pointer" container="body"
          tooltip="{{ 'TOOLTIPS.delete' | translate }}" aria-hidden="true"
          (click)="elementDeleted(variable, nested, type)">
      </em>
    </div>
  </div>
</ng-template>

